/**
 * Пути, которые приложение берёт себе. Список совпадает с intent-filter в AndroidManifest.xml и
 * с AASA (public/.well-known): ссылка вне списка принадлежит браузеру. Своя же ссылка из чата
 * на `/unsubscribe`, `/oauth2/...` или `/sitemap.xml` внутри приложения открыла бы пустую
 * страницу 404.
 *
 * Весь `/dashboard` не берём намеренно: туда же приходит человек после входа с сайта.
 */

/** Поддерево: страница `<корень>/...`, но не соседи вроде `/dashboard/chatsfoo`. */
const APP_LINK_TREES = ['/posts', '/players', '/blog'];

/** Раздел: сам путь и всё под ним. */
const APP_LINK_SECTIONS = ['/dashboard/chats', '/dashboard/discover', '/dashboard/posts'];

/** Одиночные экраны: только они сами. */
const APP_LINK_SCREENS = ['/confirm-registration', '/dashboard/settings/notifications'];

const LOCALE_PREFIX = /^\/ru(?=\/)/;

export const isAppLinkable = (path: string): boolean => {
  const queryAt = path.search(/[?#]/);
  const pathname = (queryAt === -1 ? path : path.slice(0, queryAt)).replace(LOCALE_PREFIX, '');
  const trimmed = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;

  return (
    APP_LINK_SCREENS.includes(trimmed) ||
    APP_LINK_SECTIONS.some((root) => trimmed === root || trimmed.startsWith(`${root}/`)) ||
    APP_LINK_TREES.some((root) => trimmed.startsWith(`${root}/`))
  );
};
